export class TableSourceProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "format",
            "baseName": "format",
            "type": "TableFormat",
            "format": ""
        },
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "start",
            "baseName": "start",
            "type": "TableSourceStart",
            "format": ""
        },
        {
            "name": "unsupportedSnapshotPolicy",
            "baseName": "unsupportedSnapshotPolicy",
            "type": "UnsupportedSnapshotPolicy",
            "format": ""
        },
        {
            "name": "removalPolicy",
            "baseName": "removalPolicy",
            "type": "RemovalPolicy",
            "format": ""
        },
        {
            "name": "pollIntervalSeconds",
            "baseName": "pollIntervalSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "partitionFields",
            "baseName": "partitionFields",
            "type": "Array<PartitionField>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableSourceProperties.attributeTypeMap;
    }
    constructor() {
    }
}
